import { defineComponent as _defineComponent } from 'vue'
import AppButton from "@/components/AppButton.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    maxFileSizeBytes: null,
    fileTypeLabel: { default: "video" },
    accept: { default: "video/*" }
  },
  emits: ["upload"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "upload", file: File): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { maxFileSizeBytes?: number, fileTypeLabel: string, accept: string }





const maxFileSizeMegabytes = computed(() => {
  return props.maxFileSizeBytes ? (props.maxFileSizeBytes / 1024 / 1024).toFixed(0) : undefined;
});

const handleUploadedFile = (file: File) => {
  if (props.maxFileSizeBytes && file.size > props.maxFileSizeBytes) {
    alert(`Files must be less than ${maxFileSizeMegabytes.value}MB. Your file is ${maxFileSizeMegabytes.value}MB.`);
  } else {
    emits("upload", file);
  }
};

const onFileUpload = ({ target }: Event) => {
  if (target instanceof HTMLInputElement) {
    const file = target.files?.[0];

    if (file) {
      handleUploadedFile(file);
    }
  }
};

const onFileDrop = (ev: DragEvent) => {
  if (ev.dataTransfer?.items) {
    const item = ev.dataTransfer.items[0];

    if (item && item.kind === "file") {
      const file = item.getAsFile();

      if (file) {
        handleUploadedFile(file);
      }
    }
  } else {
    const file = ev.dataTransfer?.files[0];

    if (file) {
      handleUploadedFile(file);
    }
  }
};

return { __sfc: true,emits, props, maxFileSizeMegabytes, handleUploadedFile, onFileUpload, onFileDrop, AppButton }
}

})